module.exports = __webpack_public_path__ + "img/logo_1024.ba4dfc5b.png";